module.exports = __webpack_public_path__ + "static/images/group-success.c41ca6d.png";